import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom/cjs/react-router-dom";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import {
  EMPTY_STRING,
  configurationsConstants,
} from "../../../../../../../constants";
import { customToast } from "../../../../../../../shared/utility";
import SelectField from "../../../../../../../shared/components/Fields/SelectField";
import SectionHeader from "../../../../../../../shared/components/Events/SectionHeader";
import { customerDashboardActions } from "../../../../../../../redux/actions";

const ReviewYourSb = (props) => {
  const { t } = useTranslation("common");
  const { groupEventId, eventId } = useParams();

  const [reviewData, setReviewData] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);

  useEffect(() => {
    if (props?.reviewFormData && props.reviewFormData[0]) {
      const initializedData = props.reviewFormData.map((sb) => ({
        sbUserId: sb?.sbUser?.id,
        reviewId: sb?.sbUser?.sbReviews?.[0]?.id,
        rating: sb?.sbUser?.sbReviews?.[0]?.reviews || 0,
        feedback: sb?.sbUser?.sbReviews?.[0]?.feedback || EMPTY_STRING,
        isSelected: false,
      }));
      setReviewData(initializedData);
    }
    // eslint-disable-next-line
  }, [props.reviewFormData]);

  const handleRatingChange = (value, index) => {
    setReviewData((prevData) =>
      prevData.map((item, i) =>
        i === index ? { ...item, rating: value } : item
      )
    );
  };

  const handleFeedbackChange = (value, index) => {
    setReviewData((prevData) =>
      prevData.map((item, i) =>
        i === index ? { ...item, feedback: value } : item
      )
    );
  };

  const handleSelection = (index) => {
    setReviewData((prevData) =>
      prevData.map((item, i) =>
        i === index ? { ...item, isSelected: !item.isSelected } : item
      )
    );
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const selectedReviews = reviewData.filter((item) => item.isSelected);

    if (selectedReviews.length === 0) {
      customToast(
        "please select at least 1 shutterb to review",
        toast.TYPE.ERROR
      );
      return;
    }

    // check if any selected review is missing a rating
    const hasInvalidRating = selectedReviews.some(
      (review) => !review.rating || review.rating <= 0
    );

    if (hasInvalidRating) {
      customToast(
        "Please give rating for all selected shutterb",
        toast.TYPE.ERROR
      );
      return;
    }

    const dataToSend = selectedReviews.map((review) => ({
      id: review.reviewId,
      userId: props.userId,
      sbuserId: review.sbUserId,
      eventId: selectedEvent.id,
      reviews: review.rating,
      feedback: review.feedback,
    }));

    props.submitRatingAndFeedback(dataToSend);
  };

  const handleEventSelect = (e) => {
    setSelectedEvent(e);
  };

  useEffect(() => {
    if (groupEventId) {
      props.getAllEventsByGroupId(groupEventId);
    }
    // eslint-disable-next-line
  }, [groupEventId]);

  useEffect(() => {
    if (props.allEvents.length) {
      setSelectedEvent(props.allEvents?.find((event) => event.id === eventId));
    }
    // eslint-disable-next-line
  }, [props.allEvents]);

  useEffect(() => {
    if (selectedEvent) {
      props.getReviewFormData(selectedEvent.id);
    }
    // eslint-disable-next-line
  }, [selectedEvent]);

  return (
    <div className="my-4 extend-sb">
      <div class="card">
        {props.allEvents?.length > 0 && (
          <SectionHeader
            eventId={eventId}
            groupId={groupEventId}
            itemCount={props.allEvents.length || 0}
            isGroup={props.allEvents.length > 1}
            title={
              props.allEvents.length > 1
                ? props.allEvents[0]?.eventGroupName
                : props.allEvents[0]?.eventName
            }
            className="px-3"
          />
        )}
        <div class="card-body tip-shutterb-wrapper">
          {props.allEvents?.length > 1 && (
            <div className="col-md-6 col-12 mb-3 px-0">
              <SelectField
                options={props.allEvents ?? []}
                id="select-event"
                label="select an event:"
                placeholder="select an event"
                labelKey="eventName"
                valueKey="id"
                value={selectedEvent}
                setValue={handleEventSelect}
              />
            </div>
          )}
          {!props.reviewFormData || props.reviewFormData?.length === 0 ? (
            <p className="text-center">
              the event request has not been accepted by any shutterb yet.
            </p>
          ) : (
            <>
              <div className="shutterb-review-header">
                <h6>review the work of your shutterb</h6>
                <p class="text-muted">
                  please select at least 1 shutterb to review
                </p>
              </div>
              {/* list of all shutterbs of event */}
              <div className="row px-0">
                <form className="col px-0" onSubmit={handleSubmit} autoComplete="off">
                  {props.reviewFormData.map((sb, index) => (
                    <div
                      key={sb.id}
                      className="py-2 shutterb-list row d-flex justify-content-start mb-3"
                    >
                      <div className="col-12 col-lg-4 col-xl-3 px-2">
                        <div class="profile-card">
                          <div class="avatar-wrapper">
                            <input
                              type="checkbox"
                              name="allEventCheckbox"
                              onClick={() => handleSelection(index)}
                              checked={reviewData[index]?.isSelected}
                              className="profile-card-checkbox"
                            />
                            <img
                              src={`${process.env.REACT_APP_S3_BASE_URL_PORTFOLIO}/${sb?.sbUser?.sbPortfolios[0]?.profileImageUrl}`}
                              alt=""
                              className="avatar-image img-fluid rounded-circle"
                            />
                          </div>
                          <h6 className="shutterb-name mt-2">
                            {`${sb?.sbUser?.firstName} ${sb?.sbUser?.lastName}`}
                          </h6>
                        </div>
                      </div>
                      <div className="col-12 col-lg-8 col-xl-9 px-2">
                        <div className="rating-container">
                          <h6>
                            give your shutterb a rating so we know how they did!
                          </h6>

                          <div className="d-flex align-items-center">
                            {/* Render star icons based on the selected rating */}
                            {[1, 2, 3, 4, 5].map((value) => (
                              <span
                                key={value}
                                className={`rating ${
                                  value <= reviewData[index]?.rating
                                    ? "active"
                                    : ""
                                }`}
                                onClick={() => handleRatingChange(value, index)}
                              >
                                &#9733;
                              </span>
                            ))}
                          </div>
                        </div>
                        <div className="feedback-container mt-3">
                          <h6>
                            we’d love to hear a bit more! feel free to leave
                            comments and feedback below from your shutterb
                            experience.
                          </h6>

                          <textarea
                            name="feedback"
                            id="feedback"
                            className="feedback-textarea px-2 py-3"
                            maxLength={
                              configurationsConstants.TEXTAREA_INPUT_LENGTH
                            }
                            value={reviewData[index]?.feedback || ""}
                            onChange={(event) =>
                              handleFeedbackChange(event.target.value, index)
                            }
                            rows="3"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  ))}
                  <div className="px-0">
                    <button type="submit" className="">
                      {t("Submit")}
                    </button>
                  </div>
                </form>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

// Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  userId: state.authentication.userId,
  allEvents: state.customerDashboard.allEvents,
  eventDetails: state.customerDashboard.eventDetails,
  reviewFormData: state.customerDashboard.reviewFormData,
});

// Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  getReviewFormData: (eventId) =>
    dispatch(customerDashboardActions.getReviewFormData(eventId)),
  submitRatingAndFeedback: (data) =>
    dispatch(customerDashboardActions.submitRatingAndFeedback(data)),
  getAllEventsByGroupId: (groupEventId) =>
    dispatch(customerDashboardActions.getAllEventsByGroupId(groupEventId)),
});

// mapping action and store the function via props
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ReviewYourSb));
